export const TRANSLATIONS_ES_DASHBOARD_AND_KNOWLEDGE = {
  "dashboard.title": "Dashboard",
  "dashboard.documents": "Documentos",
  "dashboard.credits": "Créditos",
  "dashboard.users": "Usuarios Activos",
  "dashboard.questions": "Preguntas",
  "dashboard.embeddings": "Embeddings",
  "dashboard.status": "Estado del Sistema",
  "dashboard.widget.plan_usage": "Uso del Plan",
  "dashboard.widget.csv_stats": "Estadísticas CSV",
  "dashboard.widget.csv_stats.uploaded": "Archivos CSV subidos",
  "dashboard.widget.csv_stats.queries": "Consultas ejecutadas",
  "dashboard.widget.documents_stats": "Estadísticas de Documentos",
  "dashboard.widget.documents_stats.count": "Documentos subidos",
  "dashboard.widget.documents_stats.duplicates": "Duplicados",
  "dashboard.widget.documents_stats.this_month": "Este mes",
  "dashboard.widget.email_stats": "Estadísticas de Correos",
  "dashboard.widget.email_stats.sent": "Emails procesados",
  "dashboard.widget.email_stats.received": "Emails convertidos en tareas",
  "dashboard.widget.tokens_breakdown": "Desglose de Tokens",
  "dashboard.widget.tokens_breakdown.input": "Tokens usados (embeddings)",
  "dashboard.widget.tokens_breakdown.output": "Tokens usados (RAG)",
  "dashboard.widget.tokens_breakdown.exceeded": "Excedido el límite de tokens",
  "dashboard.widget.rag_queries": "Consultas RAG",
  "dashboard.widget.rag_queries.count": "Consultas RAG",
  "dashboard.widget.rag_queries.top_users": "Top usuarios:",
  "dashboard.widget.plan_usage.used": "Usados",
  "dashboard.widget.plan_usage.remaining": "Restantes",
  "dashboard.widget.plan_usage.total": "Total",
  "dashboard.widget.plan_usage.exceeded": "Excedido el límite del plan",
  "dashboard.widget.user_activity": "Actividad de Usuarios",
  "dashboard.widget.inactive_users": "Usuarios Inactivos",
  "dashboard.widget.user_activity.active": "Usuarios Activos",
  "dashboard.widget.user_activity.inactive": "Usuarios Inactivos",
  "dashboard.widget.inactive_users.count": "Usuarios Inactivos",
  "dashboard.loading": "Cargando...",
  "dashboard.context_menu.add_widget": "Agregar Widget",
  "dashboard.context_menu.remove_widget": "Quitar Widget",
  "dashboard.context_menu.title": "Widgets Disponibles",
  "dashboard.context_menu.group.others": "Otros",
  "dashboard.context_menu.widget.csv": "CSV",
  "dashboard.context_menu.widget.consultas_rag": "Consultas RAG",
  "dashboard.context_menu.widget.tokens": "Tokens",
  "dashboard.context_menu.widget.emails": "Emails",
  "dashboard.context_menu.widget.documentos": "Documentos",
  "dashboard.context_menu.widget.usuarios_inactivos": "Usuarios Inactivos",
  "dashboard.empty": "Haz clic derecho para agregar widgets al dashboard.",
  "dashboard.widget.title.plan_usage": "Uso del Plan",
  "dashboard.widget.title.csv_stats": "Estadísticas CSV",
  "dashboard.widget.title.documents_stats": "Estadísticas de Documentos",
  "dashboard.widget.title.email_stats": "Estadísticas de Correos",
  "dashboard.widget.title.tokens_breakdown": "Desglose de Tokens",
  "dashboard.widget.title.rag_queries": "Consultas RAG",
  "dashboard.widget.title.user_activity": "Actividad de Usuarios",
  "dashboard.widget.title.inactive_users": "Usuarios Inactivos",
  "dashboard.context_menu.widget.plan_usage": "Uso del Plan",
  "dashboard.context_menu.widget.csv_stats": "Estadísticas CSV",
  "dashboard.context_menu.widget.documents_stats": "Estadísticas de Documentos",
  "dashboard.context_menu.widget.email_stats": "Estadísticas de Correos",
  "dashboard.context_menu.widget.tokens_breakdown": "Desglose de Tokens",
  "dashboard.context_menu.widget.rag_queries": "Consultas RAG",
  "dashboard.context_menu.widget.user_activity": "Actividad de Usuarios",
  "dashboard.context_menu.widget.inactive_users": "Usuarios Inactivos",
  "dashboard.widget.user_activity.last_active": "Última actividad",
  "dashboard.widget.user_activity.user": "Usuario",
  "dashboard.active_users_this_month": "Usuarios activos este mes:",
  "dashboard.active_users_today": "Usuarios activos hoy",
  "dashboard.name": "Nombre",
  "dashboard.last_login": "Último login",
  "dashboard.last_activity": "Última actividad",
  "dashboard.inactive_users_this_month": "Usuarios inactivos este mes:",
  "dashboard.days_without_activity": "días sin actividad",
  "dashboard.no_inactive_users": "No hay usuarios inactivos este mes.",
  "dashboard.questions_today": "Preguntas hoy",
  "dashboard.system_status": "Estado del sistema",
  "dashboard.action": "Acción",
  "dashboard.context_menu.no_widgets": "No hay widgets para agregar",
  "changes.title": "Cambios entre versiones",
  "changes.empty": "No hay cambios detectados.",
  "changes.filter.allSeverities": "Todas las severidades",
  "changes.filter.allStatuses": "Todos los estados",
  "changes.general.loading": "Cargando...",
  "changes.general.retry": "Reintentar",
  "changes.error.message": "No se pudieron cargar los cambios.",
  "changes.evidence.before": "Antes",
  "changes.evidence.after": "Despues",
  "changes.action.confirm": "Confirmar",
  "changes.action.needsReview": "Por revisar",
  "changes.action.dismiss": "Descartar",
  "changes.action.dismissReason": "Motivo (opcional)",
  "changes.severity.informational": "informativo",
  "changes.severity.low": "bajo",
  "changes.severity.medium": "medio",
  "changes.severity.high": "alto",
  "changes.severity.critical": "critico",
  "changes.status.detected": "detectado",
  "changes.status.needs_review": "por revisar",
  "changes.status.confirmed": "confirmado",
  "changes.status.dismissed": "descartado",
  "changes.status.superseded": "reemplazado",
  "changes.category.legal": "legal",
  "changes.category.financial": "financiero",
  "changes.category.operational": "operativo",
  "changes.category.compliance": "cumplimiento",
  "changes.category.commercial": "comercial",
  "changes.category.technical": "tecnico",
  "changes.category.human_resources": "RRHH",
  "changes.category.security": "seguridad",
  "changes.category.general": "general",
  "alerts.title": "Alertas de conocimiento",
  "alerts.empty": "No hay alertas activas.",
  "alerts.filter.allSeverities": "Todas las severidades",
  "alerts.filter.allStatuses": "Todos los estados",
  "alerts.filter.allSources": "Todas las fuentes",
  "alerts.general.loading": "Cargando...",
  "alerts.general.retry": "Reintentar",
  "alerts.error.message": "No se pudieron cargar las alertas.",
  "alerts.severity.informational": "informativo",
  "alerts.severity.low": "bajo",
  "alerts.severity.medium": "medio",
  "alerts.severity.high": "alto",
  "alerts.severity.critical": "critico",
  "alerts.status.detected": "detectada",
  "alerts.status.acknowledged": "reconocida",
  "alerts.status.snoozed": "pospuesta",
  "alerts.status.resolved": "resuelta",
  "alerts.status.dismissed": "descartada",
  "alerts.status.expired": "expirada",
  "alerts.source.expiration": "vencimiento",
  "alerts.source.change": "cambio",
  "alerts.refs.title": "Referencias de origen",
  "alerts.refs.open": "Abrir origen",
  "alerts.action.acknowledge": "Reconocer",
  "alerts.action.snooze": "Posponer",
  "alerts.action.snoozeDays": "Dias",
  "alerts.action.resolve": "Resolver",
  "alerts.action.dismiss": "Descartar",
  "alerts.action.dismissReason": "Motivo (opcional)",
  "alerts.action.openSource": "Ver en origen",
  "dashboard.knowledge.title": "Panel de conocimiento",
  "dashboard.knowledge.loading": "Cargando...",
  "dashboard.knowledge.error": "No se pudo cargar el panel.",
  "dashboard.knowledge.retry": "Reintentar",
  "dashboard.knowledge.placeholder": "Sin datos por ahora.",
  "dashboard.knowledge.changesBySeverity": "Cambios por severidad",
  "dashboard.knowledge.changesByCategory": "Cambios por categoria",
  "dashboard.knowledge.expirationsByHorizon": "Vencimientos por horizonte",
  "dashboard.knowledge.alertsByStatus": "Alertas por estado",
  "knowledge.title": "Conocimiento",
  "knowledge.tabs.entities": "Entidades",
  "knowledge.tabs.expirations": "Vencimientos",
  "knowledge.loading": "Cargando…",
  "knowledge.retry": "Reintentar",
  "knowledge.entities.subtitle": "Entidades detectadas en tus documentos.",
  "knowledge.entities.searchPlaceholder": "Buscar por nombre o alias…",
  "knowledge.entities.search": "Buscar",
  "knowledge.entities.sources": "Fuentes",
  "knowledge.entities.empty": "No hay entidades para mostrar.",
  "knowledge.entities.error": "No se pudieron cargar las entidades.",
  "knowledge.timeline.title": "Línea de tiempo",
  "knowledge.timeline.empty": "No hay eventos legibles para esta entidad.",
  "knowledge.timeline.error": "No se pudo cargar la línea de tiempo.",
  "knowledge.expirations.subtitle": "Próximos vencimientos detectados con evidencia.",
  "knowledge.expirations.evidence": "Evidencia",
  "knowledge.expirations.dismiss": "Descartar",
  "knowledge.expirations.dismissed": "Vencimiento descartado.",
  "knowledge.expirations.dismissError": "No se pudo descartar el vencimiento.",
  "knowledge.expirations.empty": "No hay vencimientos próximos.",
  "knowledge.expirations.error": "No se pudieron cargar los vencimientos.",
  "knowledge.type.cliente": "Cliente",
  "knowledge.type.proveedor": "Proveedor",
  "knowledge.type.contrato": "Contrato",
  "knowledge.type.politica": "Política",
  "knowledge.type.area": "Área",
  "knowledge.type.riesgo": "Riesgo",
};
